<template>
  <div>
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      :header-cell-style="{
        'background-color': '#EEEEEE',
        color: '#333333',
        height: '60px',
      }"
    >
      <el-table-column
        prop="name"
        label="一级项目"
        width="180"
      ></el-table-column>
      <el-table-column label="项目评分 / 满分" width="180" prop="projectScore">
        <template slot-scope="scope">
          <div v-if="scope.row.buckleType == 1 || !scope.row.buckleType">
            {{ userScore(scope.row) }} / {{ sumScore(scope.row) }}
          </div>
          <div v-else-if="scope.row.buckleType && scope.row.buckleType == 2">
            /
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="内容及评分标准"
        width="320"
        class-name="table_3"
      >
        <template slot-scope="scope">
          <div
            class="text_input"
            ref="text"
            v-for="(item, index) in scope.row.child"
            :key="index"
          >
            <el-input
              type="textarea"
              autosize
              placeholder="请输入内容"
              readonly
              v-model="item.content"
            ></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="分值" width="80" class-name="table_3">
        <template slot-scope="scope">
          <div
            class="text_input"
            style="line-height: 75px"
            v-for="(item, index) in scope.row.child"
            :key="index"
          >
            <template>
              <div v-if="scope.row.buckleType == 1 || !scope.row.buckleType">
                {{ item.scoreValue }}
              </div>
              <div
                v-else-if="scope.row.buckleType && scope.row.buckleType == 2"
                class="text_left"
              >
                (扣分项)
              </div>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="score"
        label="得分"
        width="220"
        class-name="table_3"
      >
        <template slot-scope="scope">
          <div
            class="text_input"
            style="line-height: 75px"
            v-for="(item, index) in scope.row.child"
            :key="index"
          >
            <el-input-number
              v-if="scope.row.buckleType == 1 || !scope.row.buckleType"
              v-model.trim="item.userValue"
              :step="0.5"
              :min="total == 0 ? scope.row.score : 0"
              :max="Number(item.scoreValue)"
              @input="checkScore(scope.row.score, scope.row, scope.$index)"
              :disabled="$parent.state == 2"
            ></el-input-number>
             <!-- 扣分项 -->
            <el-input-number
              v-else-if="scope.row.buckleType && scope.row.buckleType == 2"
              v-model.trim="item.userValue"
              @input="changeNum(item.userValue, scope.$index, index)"
              @change="changeNum(item.userValue, scope.$index, index)"
              :disabled="$parent.state == 2"
            ></el-input-number>
            <p
               v-else-if="scope.row.buckleType && scope.row.buckleType == 2"
              class="red1 text_left"
            >
              注：此项为负分项
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="扣分细节"
        width="320"
        class-name="table_3"
      >
        <template slot-scope="scope">
          <div
            class="text_input"
            ref="text"
            v-for="(item, index) in scope.row.child"
            :key="index"
          >
            <el-input
              type="textarea"
              autosize
              placeholder="请输入扣分细节"
              v-model="item.userTxte"
            ></el-input>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <div>合计</div>
      <div>{{ totalScores(tableData) }}</div>
      <div></div>
      <div></div>
      <div>{{ userTotal(tableData) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //   tableData: [],
      total: "", // 得分
      Scores: "", // 总分
    };
  },
  props: ["tableData"],
  methods: {
    // 判断当前是否数字
    checkScore(row, obj, index) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (isNaN(row) == true) {
          this.$message({
            message: "警告，分数必须是数字",
            type: "warning",
          });
          this.tableData[index].score = ""; // 清除当前输入框分数
        }
        if (row > Number(obj.projectScore)) {
          this.$message({
            message: "警告，当前得分不能超过当前项目分",
            type: "warning",
          });
          // 默认将当前分数为项目分
          this.tableData[index].score = this.tableData[index].projectScore;
        }
      }, 500);
    },
     changeNum(num, index, sindex) {
      //扣分计算
      if (num > 0) {
        this.$nextTick(() => {
          this.tableData[index].child[sindex].userValue = -num;
          this.changeNum(-num, index, sindex);
        });
        return;
      }
      let afterDya = JSON.parse(JSON.stringify(this.tableData));
      let newarr = [];
      afterDya.splice(index, 1);
      // afterDya[index].child.splice(sindex,1)
      console.log(afterDya);
      afterDya.forEach((item) => {
        afterDya = item.child.forEach((zitem) => {
          newarr.push(zitem);
        });
      });
      console.log(newarr);
      let targetNUm = newarr.reduce((first, scend) => {
        return first + Number(scend.userValue);
      }, 0);
      console.log(targetNUm, "targetNUm");
      let disabledNum = -targetNUm;
      console.log(num, "num");
      if (num <= disabledNum) {
        this.$nextTick(() => {
          this.tableData[index].child[sindex].userValue = disabledNum;
        });
        // console.log("after", this.tableData);
      }
    },
  },
  computed: {
    // 计算二级小节的合计
    sumScore() {
      return function (row) {
        row.projectScore = row.child.reduce(
          (a, curr) => a + Number(curr.scoreValue),
          0
        );
        return row.projectScore;
      };
    },
    // 计算用户得分
    userScore() {
      return function (row) {
        row.score = row.child.reduce(
          (a, curr) => a + Number(curr.userValue),
          0
        );
        return Number(row.score);
      };
    },
    // 计算一共的项目分总和
    totalScores() {
      return function (arr) {
         arr = arr.filter((item) => {
          // return item.buckleType == 1; // 过滤出非扣分项目
          if (!item.buckleType || item.buckleType == 1) {
            return item;
          }
        });
        let newarr = arr.map((item) => {
          return Number(item.projectScore);
        });
        let num = 0;
        for (var i = newarr.length - 1; i >= 0; i--) {
          num += newarr[i];
        }
        this.Scores = num;
        return num;
      };
    },
    // 计算用户得分
    userTotal() {
      return function (arr) {
        let newarr = arr.map((item) => {
          //   return item.score;
          return item.child.map((zitem) => {
            return zitem.userValue;
          });
        });
        newarr = newarr.flat();
        let num = 0;
        for (var i = newarr.length - 1; i >= 0; i--) {
          num += newarr[i];
        }
        this.total = num;
        return num;
      };
    },
    
  },
  created() {
    // this.tableData = this.$parent.tableData;
  },
};
</script>

<style lang="scss" scoped>
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  min-width: 88px;
  height: 40px;
  opacity: 1;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 112px;
    height: 40px;
    background: #ebecf1;
    border-radius: 3px;
    letter-spacing: 1px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #000000;
    &:nth-child(1) {
      min-width: 140px;
    }
    span {
      display: flex;
      align-items: center;
    }
    span > img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
::v-deep .el-table__cell {
  text-align: center;
}
.cell {
  text-align: center;
}
.red {
  border: 1px solid red;
  border-radius: 4px;
  &:focus {
    border-color: red !important;
  }
}
.add_bz {
  //   margin-top: 24px;
  background: #409eff !important;
  color: #fff !important;
}
.text_input {
  margin-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
  padding: 0px 10px 6px 10px;
  height: 75px;

  &:last-child {
    border: none !important;
  }
  ::v-deep .el-textarea__inner {
    // max-height: 60px !important;
    resize: none;
    height: 70px !important;
  }
}
::v-deep .table_3 {
  .cell {
    padding: 0 !important;
  }
}
.modify {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    display: flex;
    align-items: center;
    p {
      width: 140px;
    }
    ::v-deep .el-input__inner {
      width: 280px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 500px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
      }
    }
  }
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: #fff;
}
::v-deep .el-dialog__header {
  height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;
  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  button {
    width: 80px;
    height: 40px;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    &:nth-child(1) {
      background: #c4c4c4;
      margin-right: 10px;
    }
    &:nth-child(2) {
      background: #0084ea;
    }
  }
}
.footer {
  height: 60px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-top: none;
  display: flex;
  div {
    height: 60px;
    line-height: 60px;
    text-align: center;
    border-right: 1px solid #ebeef5;
    &:nth-child(1) {
      width: 180px;
    }
    &:nth-child(2) {
      width: 180px;
    }
    &:nth-child(3) {
      width: 320px;
    }
    &:nth-child(4) {
      width: 80px;
    }
    &:nth-child(5) {
      width: 220px;
    }
  }
}
</style>